import { Box, Stack, Text, Title, useMantineTheme } from '@mantine/core'
import { useRef } from 'react'
import { Link } from 'react-router-dom'

import defaultImage from '../../assets/webp_converted/imageOnload.webp'
import { globalConstants } from '../../constants/content'
import { Draft, formattedDateTime } from '../../utils/utils'
import { truncate } from '../Discover/GalleryCard'
import { ImageCrop } from '../MediaWrappers/ImageCrop'
import ImageWrapper from '../MediaWrappers/ImageWrapper'

const CARD_SIZE = 300

interface CreationsCardProps {
  title: string
  description?: string
  image?: string
  templateId?: string
  draftData?: Draft
  timestamp?: string | number
  filesize?: string
}

const CreationsCard: React.FC<CreationsCardProps> = ({
  title,
  description = '',
  image = defaultImage,
  templateId = '',
  draftData = {
    name: '',
    description: '',
    asset: '',
    cropInfo: {
      x: 0,
      y: 0,
      width: globalConstants.CROP_IMAGE_SIZE.width,
      height: globalConstants.CROP_IMAGE_SIZE.height,
      rotate: 0,
      scaleX: 1,
      scaleY: 1,
    },
    tags: [],
    royalties: 0,
    creatorSplit: 100,
    nCreatorsSplit: [],
    storage: '',
  },
  timestamp = '',
  filesize = '',
}) => {
  const theme = useMantineTheme()
  const parentRef = useRef<HTMLDivElement>(null)
  return (
    <Stack style={{ position: 'relative' }} ref={parentRef}>
      <Link
        to={!draftData.asset ? `./templates/${templateId}` : './createitem'}
        state={{ draftData }}
        style={{ textDecoration: 'none' }}
      >
        <Box
          style={{
            backgroundColor: theme.colors.background2[0],
            borderRadius: '6px',
            textAlign: 'center',
            cursor: 'pointer',
          }}
        >
          {!draftData.asset ? (
            <ImageWrapper
              src={image}
              alt="Dropped"
              style={{
                backgroundColor: theme.colors.background2[0],
                borderRadius: '6px',
                maxHeight: `${CARD_SIZE}px`,
                maxWidth: `${CARD_SIZE}px`,
                height: `${CARD_SIZE}px`,
                width: `${CARD_SIZE}px`,
                textAlign: 'center',
                cursor: 'pointer',
              }}
            />
          ) : (
            <ImageCrop imageUrl={image} data={draftData?.cropInfo} parentRef={parentRef} />
          )}
        </Box>
      </Link>
      <Stack style={{ gap: 10 }}>
        {title && (
          <Title order={4} style={{ wordWrap: 'break-word' }}>
            {title}
          </Title>
        )}
        {description && (
          <Text style={{ fontSize: '14px', wordWrap: 'break-word' }}>
            {truncate(description, 90)}
          </Text>
        )}
        <Stack style={{ gap: '0px' }}>
          {timestamp && (
            <Text style={{ fontSize: '14px', wordWrap: 'break-word' }}>
              {formattedDateTime(timestamp)}
            </Text>
          )}
          {filesize && <Text style={{ fontSize: '14px', wordWrap: 'break-word' }}>{filesize}</Text>}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default CreationsCard
